import React from "react";
import FormKas from "./FormKas";
import rahel from "./../../../img/rahel1.jpg";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const InputKas = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            RT_from,
            RT_to,
            RT_zhmaraybarez,
            RT_nawibrez,
            RT_para$,
            RT_paraID,
            RT_koyparadanID,
            RT_koyparadan$,
            RT_koyparadarhinanRRR,
            RT_koyparadarhinanID,
            RT_koyparadarhinan$,
            RT_koyparadanRRR
          } = value;
          return (
            <>
              <img src={rahel} alt="rahel" />
              <div className="row mb2">
                <div className="col-4 text-right form-inline "></div>
                <div className="col-4 text-right form-inline ">
                  <div className="form-group ">
                    <label className="font-weight-bold f3 ml5">
                      ڕاپۆرتی کەس
                    </label>
                  </div>
                </div>
                <div className="col-4 text-right form-inline"></div>
              </div>

              <div
                className="row text-dark font-weight-bold f3 mx-4"
                style={{ border: "2px solid black" }}
              >
                <div className="col-3 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5 ">{RT_to}</h5>
                    <label className="font-weight-bold mb-2 ml1">
                      : بۆ بەرواری
                    </label>
                  </div>
                </div>

                <div className="col-3 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5  ">{RT_from}</h5>
                    <label className="font-weight-bold mb-2  ml1">
                      : لە بەرواری{" "}
                    </label>
                  </div>
                </div>
                {/* <div className="col-1 text-right  form-inline"></div> */}

                <div className="col-3 text-right  form-inline ">
                  <div className="form-group ">
                    <h6 className=" mt2 ml5  fk">({RT_nawibrez})</h6>
                    <label className=" f4 fk ">:بەڕێز</label>
                  </div>
                </div>

                <div className="col-3 text-right form-inline">
                  <div className="form-group ml6">
                    <h6 className="mt2  fk">{RT_zhmaraybarez}</h6>
                    <label className="font-weight-bold f4 ml2 fk">:ژمارە</label>
                  </div>
                </div>
              </div>

              <div className="mt4"></div>
              <FormKas />

              {/* Summary Section - Simple Print Design */}
              <div className="mt-4" style={{ border: "2px solid black" }}>
                <h4 className="text-center font-weight-bold py-2 m-0" style={{ borderBottom: "2px solid black", backgroundColor: "white" }}>
                  کورتەی ڕاپۆرت
                </h4>

                {/* Dollar Table */}
                <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                      <th className="text-center font-weight-bold" colSpan="6">بە دۆلار ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center text-bold" style={{ width: "13%" }}>
                        <NumberFormat
                          value={Number(RT_para$).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "20%" }}>قەرزی ئێمە</td>

                      <td className="text-center text-bold" style={{ width: "13%" }}>
                        <NumberFormat
                          value={Number(RT_koyparadarhinan$).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "20%" }}>مافی کۆمپانیا</td>

                      <td className="text-center text-bold" style={{ width: "14%" }}>
                        <NumberFormat
                          value={Number(RT_koyparadan$).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "20%" }}>کۆی پارەدان</td>

                    </tr>
                  </tbody>
                </table>

                {/* Dinar Table */}
                <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                      <th className="text-center font-weight-bold" colSpan="6">بە دینار (IQD)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center text-bold" style={{ width: "13%" }}>
                        <NumberFormat
                          value={Number(RT_paraID).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"IQD "}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "20%" }}>قەرزی ئێمە</td>

                      <td className="text-center text-bold" style={{ width: "13%" }}>
                        <NumberFormat
                          value={Number(RT_koyparadarhinanID).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"IQD "}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "20%" }}>مافی کۆمپانیا</td>

                      <td className="text-center text-bold" style={{ width: "14%" }}>
                        <NumberFormat
                          value={Number(RT_koyparadanID).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"IQD "}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "20%" }}>کۆی پارەدان</td>

                    </tr>
                  </tbody>
                </table>

                {/* Yuan Table */}
                <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                      <th className="text-center font-weight-bold" colSpan="4">بە ڕیمێمبی (¥)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center text-bold" style={{ width: "25%" }}>
                        <NumberFormat
                          value={Number(RT_koyparadarhinanRRR).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"¥"}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "25%" }}>مافی کۆمپانیا</td>

                      <td className="text-center text-bold" style={{ width: "25%" }}>
                        <NumberFormat
                          value={Number(RT_koyparadanRRR).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"¥"}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "25%" }}>کۆی پارەدان</td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default InputKas;
